import { AlignRow } from '@framework/ui';
import { Button, message } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { InputMarginContainer } from '../../../../../ui/row/InputMarginContainer';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { useWidgetEnabled } from '../../../hooks/useWidgetEnabled';
import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { IButtonWidget } from './IButtonWidget';
import { ButtonActionLogicSwitch } from './actions/ButtonActionLogicSwitch';
import { createButtonActionSubject } from './actions/ButtonActionSubject';
import { getIconFromType } from './icons/Icons';

export interface IButtonWidgetComponentProps
  extends IWidgetComponentProps<IButtonWidget> {}

export function ButtonWidgetComponent(props: IButtonWidgetComponentProps) {
  const { widget } = props;

  const options = getWidgetProps(props);
  const visible = useWidgetVisibility(props.widget, options);
  const enabled = useWidgetEnabled(widget, options);

  // Hook di antd necessario per gestire i messaggi
  // di loading durante le azioni di richiamo servizio
  const [messageApi, contextHolder] = message.useMessage();

  const buttonClickSubject = useMemo(() => createButtonActionSubject(), []);

  const handleClick = useCallback(() => {
    buttonClickSubject.next({});
  }, [buttonClickSubject]);

  if (!visible) return null;
  if (props.readonly) return null;

  return (
    <>
      {contextHolder}
      <InputMarginContainer>
        {widget.actions?.map((action, index) => (
          <ButtonActionLogicSwitch
            action={action}
            buttonWidgetOptions={options}
            onClickSubject={buttonClickSubject}
            key={index}
            widget={widget}
            index={index}
            messageApi={messageApi}
          />
        ))}
        <AlignRow justify={widget.layout?.buttonAlign ?? 'flex-end'}>
          <Button
            size="large"
            block
            type={widget.layout?.buttonType ?? 'primary'}
            icon={getIconFromType(widget.layout?.iconType)}
            children={<RichTextAdvancedRender inline text={widget.label} />}
            disabled={enabled === false}
            onClick={handleClick}
          />
        </AlignRow>
      </InputMarginContainer>
    </>
  );
}
